"use client";

import { useEffect, useCallback } from 'react';
import { useChatContext } from '@/contexts/ChatContext';
import styles from './VideoViewer.module.css';

export default function VideoViewer() {
    const { videoViewer, closeVideoViewer, nextVideo, prevVideo } = useChatContext();

    const currentVideoUrl = videoViewer ? videoViewer.urls[videoViewer.currentIndex] : null;
    const hasMultipleVideos = videoViewer && videoViewer.urls.length > 1;

    const handleKeyDown = useCallback((event: KeyboardEvent) => {
        if (!videoViewer) return;

        if (event.key === 'Escape') {
            closeVideoViewer();
        } else if (event.key === 'ArrowRight') {
            nextVideo();
        } else if (event.key === 'ArrowLeft') {
            prevVideo();
        }
    }, [videoViewer, closeVideoViewer, nextVideo, prevVideo]);

    useEffect(() => {
        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [handleKeyDown]);

    const stopPropagation = (event: React.MouseEvent) => {
        event.stopPropagation();
    };

    if (!videoViewer || !currentVideoUrl) return null;

    return (
        <div className={styles.viewerOverlay} onClick={closeVideoViewer}>
            {/* Close Button */}
            <button className={`${styles.controlBtn} ${styles.closeBtn}`} onClick={closeVideoViewer}>
                &times;
            </button>

            {/* Previous Button */}
            {hasMultipleVideos && (
                <button
                    className={`${styles.controlBtn} ${styles.navBtn} ${styles.prevBtn}`}
                    onClick={(e) => { prevVideo(); stopPropagation(e); }}
                >
                    &#x276E;
                </button>
            )}

            {/* Next Button */}
            {hasMultipleVideos && (
                <button
                    className={`${styles.controlBtn} ${styles.navBtn} ${styles.nextBtn}`}
                    onClick={(e) => { nextVideo(); stopPropagation(e); }}
                >
                    &#x276F;
                </button>
            )}

            {/* Video Container */}
            <div className={styles.videoContainer} onClick={stopPropagation}>
                <video
                    className={styles.mainVideo}
                    src={currentVideoUrl}
                    controls
                    autoPlay
                    playsInline
                >
                    Your browser does not support the video tag.
                </video>
            </div>
        </div>
    );
}
